import { useEffect, useRef } from 'react';
import pushInDataLayer from '@/utils/pushInDataLayer';
import { graphql, useStaticQuery } from 'gatsby';
import { useLocation } from '@reach/router';

const usePageViewEvent = ({ blogTags }: { blogTags: Array<Queries.ARTICLE_TAGFragment> }) => {
  // NOTE: This is a workaround to avoid sending the page view event multiple times. #SONARSITE-1883
  const done = useRef(false);

  const { site } = useStaticQuery<Queries.UsePageViewEventQuery>(graphql`
    query UsePageViewEvent {
      site {
        siteMetadata {
          isProduction
        }
      }
    }
  `);

  const { pathname } = useLocation();

  useEffect(() => {
    if (!done.current) {
      const pathParts = pathname.split('/').filter(Boolean) ?? [];

      pushInDataLayer({
        event: 'pageView',
        pageViewValue: {
          env: site?.siteMetadata?.isProduction ? 'prod' : 'preview',
          site: 'sonarsource',
          pageCategory: pathParts[0] ?? '', // first level of the path
          pageSubCategory: pathParts[1] ?? '', // second level of the path
          blogTags: blogTags.map((tag) => tag.articleTagElements.name.value).join(','),
        },
      });

      done.current = true;
    }
  }, [blogTags, pathname, site]);
};

export default usePageViewEvent;
